import { MenuItem } from '@szhsin/react-menu'
import { ExternalCalendar } from '../../../utils/calendar'
import { useLocalStorage } from 'usehooks-ts'

type ExternalCalendarListProps = {
  items: ExternalCalendar[]
}

export function ExternalCalendarList({ items }: ExternalCalendarListProps) {
  const [hiddenCalendars, setHiddenCalendars] = useLocalStorage<string[]>(
    'hiddenCalendars',
    []
  )

  function handleCalendarToggle(calendarId: string) {
    setHiddenCalendars((previous) => {
      if (previous.includes(calendarId)) {
        return previous.filter((id) => id !== calendarId)
      }
      return [...previous, calendarId]
    })
  }

  return (
    <>
      {items.map((calendar) => {
        const isChecked = !hiddenCalendars.includes(calendar.id)
        return (
          <MenuItem
            key={calendar.id}
            onClick={(event) => {
              event.keepOpen = true
              handleCalendarToggle(calendar.id)
            }}
            className='group'
          >
            <div className='flex items-center gap-3'>
              <div className='relative flex h-5 w-5 shrink-0 items-center justify-center'>
                <div
                  className={`h-4 w-4 rounded-sm border-2 transition-all duration-200 ${
                    isChecked
                      ? 'border-transparent'
                      : 'border-gray-400 bg-white dark:border-gray-600 dark:bg-gray-800'
                  }`}
                  style={isChecked ? { backgroundColor: calendar.color } : {}}
                >
                  {isChecked && (
                    <i className='fa-solid fa-check absolute inset-0 flex items-center justify-center text-xs text-white' />
                  )}
                </div>
              </div>
              <span className='text-sm'>{calendar.name}</span>
            </div>
          </MenuItem>
        )
      })}
    </>
  )
}
